import React, { useState, useEffect, useRef } from "react";
import chatIcon from "../../../imgs/chaticon-24.svg";
import HomeSidebar from "../homeSidebar/homeSidebar";
import ChatCard from "./ChatCard";
import { useSelector } from "react-redux";
import { CHAT_COUNT, GET_CHANNELS } from "../../../graphql/query/channels";
import ChatSelect from "../../ChatSelect";
import { useLazyQuery, gql } from "@apollo/client";
import { removeDuplicates, removeDuplicatesChannel } from "../../../utils/helpers/reusableFuntions";
import { Spin } from "antd";

const ChatHome = () => {
  const [channel, setChannel] = useState([]);
  const [filter, setFilter] = useState("accepted");
  const [filterActive, setFilterActive] = useState(true);
  const [filterCompleted, setFilterCompleted] = useState(false);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const loader = useRef(null);
  const [start, setStart] = useState(0);
  const [limit] = useState(10);
  const [rendering, setRendering] = useState(true);
  const [isNextRequest, setIsNextRequest] = useState(true);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    var options = {
      root: null,
      rootMargin: "20px",
      threshold: 1.0,
    };
    // initialize IntersectionObserver
    // and attaching to Load More div
    const observer = new IntersectionObserver(handleObserver, options);
    if (loader.current) {
      observer.observe(loader.current);
    }
  }, []);

  const handleObserver = (entities) => {
    const target = entities[0];
    if (target.isIntersecting) {
      setPage((page) => page + 1);
    }
  };

  useEffect(() => {
    if (isNextRequest) {
      setStart(start + 10);
      setIsNextRequest(false);
      getMyChannels({
        variables: {
          profileId: userProfile.id,
          status: filter,
          start: start + 10,
          limit,
        },
      });
    }
  }, [page]);

  const [getMyChannels, { data: myChannelList }] =
    useLazyQuery(gql(GET_CHANNELS), {
      fetchPolicy: "cache-and-network",
    });
  const userProfile = useSelector((state) => state.strapiRes);

  useEffect(() => {
    if (!channel.length && rendering) {
      setRendering(false);
      getMyChannels({
        variables: {
          profileId: userProfile.id,
          start,
          limit,
          status: filter,
        },
      });
    }
  }, []);

  useEffect(() => {
    if (myChannelList && myChannelList.getChatChannels) {
      setIsNextRequest(true);
      if (myChannelList.getChatChannels.length) {
        if (myChannelList.getChatChannels.length < 10) setHasMore(false);
        let mergeChannels = [...channel, ...myChannelList.getChatChannels];
        const result = removeDuplicates(mergeChannels);
        setChannel(
          result.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
        );
      } else {
        setHasMore(false);
      }
    }
  }, [myChannelList]);

  const handleGetChannels = () => {
    getMyChannels({
      variables: {
        profileId: userProfile.id,
        start: 0,
        limit: 2,
        status: filter,
      },
    });
  };

  const handleFilterActive = () => {
    setFilterActive(true);
    setFilter("accepted");
    setFilterCompleted(false);
    setChannel([]);
  };

  const handleFilterCompleted = () => {
    setFilter("completed");
    setFilterActive(false);
    setFilterCompleted(true);
    setChannel([]);
  };

  const [chatCount] = useLazyQuery(gql(CHAT_COUNT), {
    fetchPolicy: "cache-and-network",
    onCompleted: ({ chatCount }) => setCount(chatCount.count),
  });

  useEffect(() => {
    chatCount({
      variables: {
        profileId: userProfile?.id,
        status: filter,
      },
    });
  }, [filter]);

  return (
    <div className="home-container">
      <HomeSidebar></HomeSidebar>
      <div className="home-content chat-content">
        <div className="chat-top">
          <div className="top">
            <h2 className="heading mb-1">
              <img src={chatIcon} alt="chatIcon" className="mr-3" />
              Chat
            </h2>
            <p>Arrange meetings with your sellers</p>
          </div>
        </div>
        <div className={channel.length ? "active-btn-row" : "active-btn-row justify-content-end"}>
          {channel.length ? <p>{count} Active chat</p> : null}
          
          <ChatSelect
            handleFilterActive={handleFilterActive}
            handleGetChannels={handleGetChannels}
            handleFilterCompleted={handleFilterCompleted}
            filter={filter}
            filterActive={filterActive}
            filterCompleted={filterCompleted}
          />
        </div>
        <div className="chat-card-feeds">
          {channel && channel?.length ? (
            channel.map((item) => {
              return <ChatCard channelData={item} />;
            })
          ) : (
            <></>
          )}
          {hasMore && (
            <div className="loading" ref={loader}>
              <Spin spinning={loader} className="spin-loading" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatHome;
